'use strict';

const customizeEmbroidery = function () {
    $('body').on('click', '.customize-button-embroidery', function (event) {
        event.preventDefault();
        const $customizebtn = $(this);
        const productToken = $customizebtn.data('token');
        const melcoConfigurator = new window.MelcoConfigurator();
        const apiKey = $customizebtn.data('configkey');
        const $sessionid = $('.melcoSessionID');
        const sessionToken = $sessionid.val();
        const options = {
            onComplete: function (data) {
                $sessionid.val(data.session_id);
                $(".melcoProductToken").val(data.product.token);
                var cutData = cutPersonalizationData(data);
                $(".melcoPersonalizationData").val(JSON.stringify(cutData));
                if ($('#page-bear-builder').length > 0) {
                    var options = {
                        url: $customizebtn.data('url'),
                        method: 'POST',
                        data: {
                            pid: $customizebtn.data('pid'),
                            sessionToken: data.session_id,
                            readyToken: data.product.token,
                            personalizationData: JSON.stringify(cutData)
                        }
                    };
                    $.ajax(options).done(function (res) {
                        if (res.enabled) {
                            $('.embrodiery-required-message').hide();
                            $('.summary-add-to-bag').prop('disabled', false);
                        }
                    });
                }
                const melcoPersonalizationDataObj = cutData;
                if (melcoPersonalizationDataObj.product.view_list.length > 0) {
                    const melcoImageDataObj = melcoPersonalizationDataObj.product.view_list[0].color_list[0].design_list[0].design.element_list;
                    let melcoDetailObj = '';
                    for (let i = 0; i < melcoImageDataObj.length; i++) {
                        const selectedColorObj = melcoImageDataObj[i].color_collection.color_list;
                        const selectedAlphabateObj = melcoImageDataObj[i].lettering.alphabet_list;

                        melcoDetailObj = `${melcoDetailObj}<div class="embroidery-line row mr-0 ml-0">
                                            <div class="embroidery-line-header col-4 pl-0"><b>${$customizebtn.data('text-line')} ${i + 1}</b></div>
                                            <div class="embroidery-line-details col-8 pr-0">
                                            <div class="embroidery-line-text"><span class="label">${$customizebtn.data('text')}</span> ${melcoImageDataObj[i].lettering.text}</div>
                                            <div class="embroidery-line-color"><span class="label"> ${$customizebtn.data('color')}</span> ${selectedColorObj.name}</div>
                                            <div class="embroidery-line-font"><span class="label">${$customizebtn.data('font')}</span> ${selectedAlphabateObj.name}</div>
                                        </div></div>`;
                    }
                    $(".updateColor").empty().html(melcoDetailObj);
                }
                $(".show-embroidery-detail").removeClass('d-none');
                $('.prices-add-to-cart-actions .customize-button').addClass('btn-primary').removeClass('btn-outline-primary');
                if (sessionToken === '') {
                    $(".embroidery-option").addClass('d-none');
                    $(".add-to-cart-emb").removeClass('d-none');
                }
            },
            sessionId: sessionToken
        };
        melcoConfigurator.start(productToken, apiKey, options);
    });
};

const customizeEmbroideryCart = function () {
    $('body').on('click', '.customize-button-embroidery-cart', function (event) {
        event.preventDefault();
        const $customizebtn = $(this);
        const productToken = $customizebtn.parent().find('.melcoProductToken').val();
        const melcoConfigurator = new window.MelcoConfigurator();
        const apiKey = $customizebtn.data('configkey');
        const sessionToken = $customizebtn.parent().find('.melcoSessionID').val();
        const productID = $customizebtn.data('pid');
        const url = $customizebtn.data('action');
        const uuid = $customizebtn.data('uuid');
        const options = {
            onComplete: function (data) {
                var cutData = cutPersonalizationData(data);
                const urlParams = {
                    pid: productID,
                    uuid: uuid,
                    productToken: productToken,
                    melcoSessionID: data.session_id,
                    melcoPersonalizationData: JSON.stringify(cutData)
                };
                $customizebtn.parents('.card').spinner().start();
                $('body').trigger('cart:beforeUpdate');
                $.ajax({
                    url: url,
                    type: 'POST',
                    context: this,
                    dataType: 'json',
                    data: urlParams,
                    success: function (result) {
                        $('body').trigger('cart:update', result);
                        const $lineItem = $customizebtn.closest('.product-info');
                        const lineItemObj = result.items.filter(item => item.UUID.toString() === uuid)[0];
                        $lineItem.find('.melcoSessionID').val(lineItemObj.melcoSessionID);
                        $lineItem.find('.melcoProductToken').val(lineItemObj.melcoProductToken);
                        $lineItem.find('.melcoPersonalizationData').val(JSON.stringify(lineItemObj.melcoPersonalizationData));
                        const melcoPersonalizationDataObj = JSON.parse(lineItemObj.melcoPersonalizationData);
                        const melcoImageDataObj = melcoPersonalizationDataObj.product.view_list[0].color_list[0].design_list[0].design.element_list;
                        let melcoDetailObj = '';
                        for (let i = 0; i < melcoImageDataObj.length; i++) {
                            const selectedColorObj = melcoImageDataObj[i].color_collection.color_list;
                            const selectedAlphabateObj = melcoImageDataObj[i].lettering.alphabet_list;
                            melcoDetailObj = `${melcoDetailObj}<div class="embroidery-line row mr-0 ml-0">
                                                <div class="embroidery-line-header col-4 pl-0"><b>${$customizebtn.data('text-line')} ${i + 1}</b></div>
                                                <div class="embroidery-line-details col-8 pr-0">
                                                <div class="embroidery-line-text"><span class="label">${$customizebtn.data('text')}</span> ${melcoImageDataObj[i].lettering.text}</div>
                                                <div class="embroidery-line-color"><span class="label"> ${$customizebtn.data('color')}</span> ${selectedColorObj.name}</div>
                                                <div class="embroidery-line-font"><span class="label">${$customizebtn.data('font')}</span> ${selectedAlphabateObj.name}</div>
                                            </div></div>`;
                        }
                        $lineItem.find(".updateColor").empty().html(melcoDetailObj);
                        $.spinner().stop();
                    },
                    error: function (event) {
                        console.log(event);
                    }
                });
            },
            sessionId: sessionToken
        };
        melcoConfigurator.start(productToken, apiKey, options);
    });
};

// This script is used to fire gtm event add_payment_info on cart page for paypal payment method
const fireGtmEvent = function () {
    $('body').on('click', '.checkout-continue .paypal-checkout', function () {
        let form = {};
        form.method = 'PayPal';
        form.payment_page = 'cart';

        try {
            if (window.gtmUrls && window.gtmUrls.GTM_ajaxRoute) {
                $.ajax({
                    url: window.gtmUrls.GTM_ajaxRoute,
                    type: 'post',
                    data: form,
                    dataType: 'json',
                    success: function (data) {
                        if (data.gtmData && window.dataLayer) {
                            window.dataLayer.push(JSON.parse(data.gtmData));
                        }
                    },
                    error: function (error) {
                        window.console.error('\nmelco.js: error in {0}', error);
                    }
                });
            }
        } catch (error) {
            window.console.error('\nmelco.js: error in {0}', error);
        }
    });
};

function cutPersonalizationData(data) {
    console.log(data); // eslint-disable-line
    const melcoImageDataObj = data.product.view_list[0].color_list[0].design_list[0].design.element_list;
    var cutElementList = [];

    for (let i = 0; i < melcoImageDataObj.length; i++) {
        const defaultColorID = melcoImageDataObj[i].default_color_id;
        const defaultAlphabateID = melcoImageDataObj[i].lettering.default_alphabet_id;
        const selectedColorObj = melcoImageDataObj[i].color_collection.color_list.filter(color => color.id.toString().toUpperCase() === defaultColorID.toUpperCase())[0];
        const selectedAlphabateObj = melcoImageDataObj[i].lettering.alphabet_list.filter(alpha => alpha.id.toUpperCase() === defaultAlphabateID.toUpperCase())[0];
        var thisElement = {
            lettering: { alphabet_list: { name: selectedAlphabateObj.name }, text: melcoImageDataObj[i].lettering.text },
            color_collection: { color_list: { name: selectedColorObj.name } }
        };
        console.log(melcoImageDataObj[i]); // eslint-disable-line
        console.log(thisElement); // eslint-disable-line
        cutElementList[i] = thisElement;
    }
    return { product: { view_list: [{ color_list: [{ design_list: [{ design: { element_list: cutElementList } }] }] }] } };
}

module.exports = {
    customizeEmbroidery: customizeEmbroidery,
    customizeEmbroideryCart: customizeEmbroideryCart,
    fireGtmEvent: fireGtmEvent
};
